import React, { useMemo } from "react";
import { css, useTheme } from "@emotion/react";

import Collapse from "core/Components/Collapse";
import useBreakpoint from "core/hooks/useBreakpoint";
import { isBetween } from "theme/breakpoints";

type Props = {
    children: React.ReactNode,
    showBurgerMenu: boolean,
};

const BurgerNavMainContainer: React.FC<Props> = ({ children, showBurgerMenu }) => {
    const theme = useTheme();
    const { breakpoint } = useBreakpoint();
    const headerHeight = useMemo(() => {
        switch (true) {
            case isBetween(breakpoint, 'sm', 'lg'):
                return theme.sizes.menu.burgerHeightMain + theme.sizes.menu.breadcrumbBurgerHeight;
            default:
                return theme.sizes.menu.breadcrumbBurgerSmallHeight + theme.sizes.menu.burgerHeightMain + theme.sizes.menu.breadcrumbBurgerHeight;
        }
    }, [
        breakpoint,
        theme.sizes.menu.burgerHeightMain,
        theme.sizes.menu.breadcrumbBurgerHeight,
        theme.sizes.menu.breadcrumbBurgerSmallHeight,
    ]);

    const style = css`
        display: flex;
        width: 100%;
        height: calc(100vh - ${headerHeight}px);
    `;

    return (
        <Collapse isOpen={showBurgerMenu}>
            <div css={style}>
                {children}
            </div>
        </Collapse>
    );
};

export default BurgerNavMainContainer;
